import React from 'react';
import {useContext} from 'react';
//import "./style.css";
import { Navigate, useParams} from 'react-router-dom';

//import Bd from "../../bd"

/*
esta é a página inicial do assistir aula
ela pega os dados do bando de dados e passa para a página carregar

nela tambem seria feito a requisição do servidor pedindo o progresso so usuario
*/

import Header   from '../../components/Header';
import Footer   from '../../components/MFooter'
import Loading   from '../../components/Loading'

import VideoMain from './VideoMain'

import {useFetch} from '../../hooks/useFetch'
//import useFind from '../../hooks/useFind'
//import     api from '../../services/api'
import {UserContext} from '../../hooks/UserContext'

function Page (props) {
    const { user } = useContext(UserContext);
    //-dj//console.log("vi",user)
    // pegando valores do url ou das props, padrão é 0
    const params = useParams();
    const p_mundo = Number(params.id_mundo || props.id_mundo || 1 )
    const p_fase  = Number(params.id_fase  || props.id_fase  || 1 )

    // buscando detalhes do mundo
    const {data: mundoData} = useFetch(`p/mundos/${p_mundo}`);
    //const faseUser{data: fuData ,mutate:fuMutate} = useFetch(`user/fu${user.id}`);
    const faseUser = useFetch(`user/fu${user.id}`);//{data: fuData ,mutate:fuMutate}

    if (!mundoData) {return (<Loading texto='Organizando o espaço'/>)}
    //-dj//console.log("\n------------------------\n mundoData",mundoData)

    // enquanto ta carregando... não fazer nada
    if (!faseUser?.data) {return <Loading texto='Listando de videos'/>}
    //if (isLoadingMundo || isLoadingUser) return <h1>Carregando</h1>
    if (!mundoData || !mundoData.fases) {
        return (<Navigate to="/404"/>)
    }

    if (mundoData.fases.length ===0) {
        return (<Navigate to="/404"/>)
        // return (<Loading texto='Não encontrei'/>)
    }

    // const id_pass = [
    //     1 ,/*ed*/
    //     61,/*alessandra*/
    //     58,/*leandro*/
    //     13,/*nelson*/
    //     14,/*patrick*/
    //     5,/*karla*/
    //     302,/*thyberio*/
    // ]

    // if (p_mundo>=4 && !id_pass.includes(user.id) && user.patente<3) {
    //     return (<Navigate to="/planetas/block/2"/>)
    // }

    //-dj//console.log('fases',mundoData.fases)
    // teste se usuario tem permissão: //<<
    // if (p_mundo===7) {
    //     return (<Navigate to="/planetas/block/3"/>)
    // }


  return (
    <div>
      {/* menu superior do dj*/}
      <Header />
      {/*
      */}
      {/*Conteudo */}
      <VideoMain
        mundoData={mundoData}
        userData={user}
        faseUser={faseUser}
        p_mundo={p_mundo}
        p_fase={p_fase}
      />
      {/*Rodape da sophia*/}
      <Footer />
    </div>
    );

};

export default Page;

//------------------------------------------
//------------------------------------------
//------------------------------------------
//------------------------------------------

/*
// mock do bd
const userData={
  mundoStop:0,
  faseStop:0,
  mundos:{
    0:[0],
  },
  fases:[0],
}// vem do bd << dj.ad


const videoMainData = {
      mundosData : Bd
}*/
